import type {Take} from '../domain/model';

export function readVideoMetadata(file: File): Promise<Pick<Take, 'durationSeconds' | 'width' | 'height'>> {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    const url = URL.createObjectURL(file);
    const timer = setTimeout(() => done({}), 8000);
    const done = (value: Pick<Take, 'durationSeconds' | 'width' | 'height'>) => {
      clearTimeout(timer); video.onloadedmetadata = null; video.onerror = null; video.removeAttribute('src');
      URL.revokeObjectURL(url);
      resolve(value);
    };
    video.preload = 'metadata';
    video.onloadedmetadata = () => done({ durationSeconds: video.duration, width: video.videoWidth, height: video.videoHeight });
    video.onerror = () => done({});
    video.src = url;
  });
}
